<template>
  <div class="projects">
    <h1>Projects coming soon...</h1>
    <p>Stay Tuned!!</p>
  </div>
</template>

<script>
export default {

}
</script>

<style>

.projects {
  font-weight: 400;
  margin-left: 50%;
  transform: translateX(-50%);  
  width: 80%;
  background: #F6F8FF;
  padding: 5%;
  text-align: center;
  margin-top: 10%;
}

.projects h1 {
  color: #868FBB;
}

.projects p {
  color: #868FBB;
  font-size: 1.5em;
}

</style>